<script setup>
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";

defineProps({
  identifier: { type: String, default: null },
});
</script>

<template>
  <div
    v-if="identifier"
    class="flex items-center gap-2 text-sm text-foreground/90"
  >
    <SvgIcon
      name="sli-identification"
      class="h-4 w-4 shrink-0 text-muted-foreground"
      aria-hidden="true"
      style="fill: none"
    />
    <div class="truncate">
      {{ identifier }}
    </div>
  </div>
</template>
